import { gql } from '@apollo/client'

export const OPERATING_HOUR_FRAGMENT = gql`
  fragment OperatingHour on OperatingHour {
    id
    closes
    opens
  }
`
